export class NavigationComponent {
    public static SELECTOR = ".navigation";
    public static HEAD_SELECTOR = ".navigation__head";
    public static MENU_SELECTOR = ".navigation__main__item";
    public static SUBMENU_SELECTOR = ".navigation__dropdown__item.has--submenu";
    public static DROPDOWN_SELECTOR = ".navigation__dropdown";
    public static DROPDOWN_CONTAINER_SELECTOR = ".navigation__dropdown__container";
    public static TEAMS_SELECTOR = ".navigation__teams";
    public static TOGGLE_TEAMS_SELECTOR = "[data-nav-toggle-teams]";
    public static DROPDOWN_TOGGLE_CLASS = "is--open";
    public static NAV_STICKY_CLASS = "is--sticky";

    public static autoInit(): NavigationComponent[] {
        const navs = document.querySelectorAll(NavigationComponent.SELECTOR) as NodeListOf<HTMLElement>;
        return Array.from(navs).map((nav) => new this(nav));
    }

    private navContainer: HTMLElement;
    private navHeadElement: HTMLElement;
    private navDropdownElement: HTMLElement;
    private navTeamsElement: HTMLElement;
    //
    private currentDropdownMenu: string;

    private tempEventListener: EventListener;
    private tempTimeout: number;
    private tempTimeoutMenuEnter: number;

    constructor(nav: HTMLElement) {
        this.navContainer = nav;

        this.navDropdownElement = this.navContainer.querySelector(NavigationComponent.DROPDOWN_SELECTOR) as
            HTMLElement;

        this.navHeadElement = this.navContainer.querySelector(NavigationComponent.HEAD_SELECTOR) as
            HTMLElement;

        this.navTeamsElement = this.navContainer.querySelector(NavigationComponent.TEAMS_SELECTOR) as
            HTMLElement;

        this.addEventListeners();

        this.scrollDropdownContainer(0, "instant"); // reset
    }

    private stickyNavBar(entries: IntersectionObserverEntry[]): void {
        if (window.innerWidth <= 1024) {
            return;
        }
        const entry = entries[0] as IntersectionObserverEntry;
        if (entry.isIntersecting === false) {
            this.navContainer.classList.add(NavigationComponent.NAV_STICKY_CLASS);
        } else {
            this.navContainer.classList.remove(NavigationComponent.NAV_STICKY_CLASS);
        }
    }

    private setDropdownContainerHeight(height: number) {
        this.navDropdownElement.style.height = `${height}px`;
    }

    private scrollDropdownContainer(top: number, behavior: "smooth" | "auto" | "instant" | undefined = "smooth") {
        this.navDropdownElement.scrollTo({
            top,
            behavior,
        });
    }

    private modifyDowndownContainer() {
        const dropdownContainer = this.navDropdownElement.querySelector(
            `${NavigationComponent.DROPDOWN_CONTAINER_SELECTOR}[data-name="${this.currentDropdownMenu}"]`,
        );

        if (dropdownContainer instanceof HTMLElement) {
            const rect = dropdownContainer.getBoundingClientRect();

            this.setDropdownContainerHeight(rect.height);
            this.scrollDropdownContainer(dropdownContainer.offsetTop);
        }
    }

    private createObserve(): void {
        const observer = new IntersectionObserver(this.stickyNavBar.bind(this));
        observer.observe(this.navHeadElement);
    }

    private onMouseEnterDropdown(e: MouseEvent): void {
        clearTimeout(this.tempTimeout);

        const currentTarget = e.currentTarget as HTMLElement; // Hovered element
        this.tempTimeoutMenuEnter = window.setTimeout(() => {
            this.navDropdownElement.classList.add(NavigationComponent.DROPDOWN_TOGGLE_CLASS);

            const dataTarget = currentTarget.dataset.target;

            if (dataTarget) {
                this.currentDropdownMenu = dataTarget; // Name of target dropdown container
            }

            // Run next tick
            setTimeout(() => {
                this.modifyDowndownContainer();
            });
        }, 500);
    }

    private onMouseLeaveDropdown(): void {
        clearTimeout(this.tempTimeoutMenuEnter);

        this.tempTimeout = window.setTimeout(() => {
            this.navDropdownElement.classList.remove(NavigationComponent.DROPDOWN_TOGGLE_CLASS);
        }, 500);
    }

    private onClickTeams(e: Event): void {
        e.preventDefault();

        if (this.navTeamsElement.classList.contains(NavigationComponent.DROPDOWN_TOGGLE_CLASS)) {
            this.navTeamsElement.classList.remove(NavigationComponent.DROPDOWN_TOGGLE_CLASS);
            this.navDropdownElement.classList.add(NavigationComponent.DROPDOWN_TOGGLE_CLASS);

            document.removeEventListener("click", this.tempEventListener);
        } else {
            this.navTeamsElement.classList.add(NavigationComponent.DROPDOWN_TOGGLE_CLASS);

            this.tempEventListener = this.onClickOutsideTeams.bind(this);
            setTimeout(() => {
                document.addEventListener("click", this.tempEventListener);
            });
        }
    }

    private onClickOutsideTeams(e: Event): void {
        const target = e.target as HTMLElement;
        if (!this.navDropdownElement.contains(target)) {
            this.navTeamsElement.classList.remove(NavigationComponent.DROPDOWN_TOGGLE_CLASS);
            document.removeEventListener("click", this.tempEventListener);
        }
    }

    private onLoad(): void {
        this.createObserve();
    }

    private addEventListeners(): void {
        const menuItems = document.querySelectorAll(NavigationComponent.MENU_SELECTOR) as
            NodeListOf<HTMLElement>;
        const submenuItems = document.querySelectorAll(NavigationComponent.SUBMENU_SELECTOR) as
            NodeListOf<HTMLElement>;
        const toggleTeams = document.querySelectorAll(NavigationComponent.TOGGLE_TEAMS_SELECTOR);

        Array.from(menuItems).map((menuItem) => {
            menuItem.addEventListener("mouseenter", this.onMouseEnterDropdown.bind(this));
            menuItem.addEventListener("mouseleave", this.onMouseLeaveDropdown.bind(this));
        });

        Array.from(submenuItems).map((submenuItem) => {
            submenuItem.addEventListener("click", (e: Event) => {
                e.preventDefault();

                const target = e.currentTarget as HTMLElement;

                if (target.classList.contains(NavigationComponent.DROPDOWN_TOGGLE_CLASS)) {
                    target.classList.remove(NavigationComponent.DROPDOWN_TOGGLE_CLASS);
                } else {
                    target.classList.add(NavigationComponent.DROPDOWN_TOGGLE_CLASS);
                }

                // Run next tick
                setTimeout(() => {
                    this.modifyDowndownContainer();
                });
            });
        });

        Array.from(toggleTeams).map((toggleTeamsItem) => {
            toggleTeamsItem.addEventListener("click", this.onClickTeams.bind(this));
        });

        this.navDropdownElement.addEventListener("mouseenter", this.onMouseEnterDropdown.bind(this));
        this.navDropdownElement.addEventListener("mouseleave", this.onMouseLeaveDropdown.bind(this));

        window.addEventListener("load", this.onLoad.bind(this));
    }
}



// WEBPACK FOOTER //
// ./components/navigation/navigation.component.ts